import React, { Component } from "react";

import blurredGlass from "assets/graphics/pictures/glass--blurred.jpg";
import blurredCover from "assets/graphics/pictures/cover--blurred.jpg";
import blurredStockings from "assets/graphics/pictures/stockings--blurred.jpg";
import blurredSwimmingPool from "assets/graphics/pictures/swimming-pool--blurred.jpg";
import glass from "assets/graphics/pictures/glass.jpg";
import cover from "assets/graphics/pictures/cover.jpg";
import stockings from "assets/graphics/pictures/stockings.jpg";
import swimmingPool from "assets/graphics/pictures/swimming-pool.jpg";

import SliderView from "features/new/slider/view";

// eslint-disable-next-line no-unused-vars
const preloadImage = (src) =>
  new Promise((resolve) => {
    const image = document.createElement("img");
    image.setAttribute("src", src);

    image.addEventListener("load", () => {
      resolve(image);
    });
  });

class Slider extends Component {
  constructor(props) {
    super(props);

    this.interval = null;

    this.state = {
      slideImages: [
        { backgroundImage: blurredGlass, image: glass, alternate: "glass" },
        { backgroundImage: blurredCover, image: cover, alternate: "cover" },
        {
          backgroundImage: blurredStockings,
          image: stockings,
          alternate: "stockings",
        },
        {
          backgroundImage: blurredSwimmingPool,
          image: swimmingPool,
          alternate: "swimming pool",
        },
      ],
      slideTexts: [
        {
          headline: "People",
          description: "Professionals, Creatives and\u00A0Notables.",
        },
        {
          headline: "Culture",
          description:
            "Art, Thought Leadership, Fashion, Music, Tech, and\u00A0more.",
        },
        {
          headline: "Connect",
          description:
            "Personal and Business Networking, Curated, Connections List",
        },
        { headline: "Wellness", description: "Mind, Body, Spirit." },
      ],
      activeSlideIndex: 2,
      sliderPosition: 0,
      isTransitioned: false,
      isSlid: false,
      isImagesLoaded: false,
    };

    this.slide = this.slide.bind(this);
    this.slideBack = this.slideBack.bind(this);
    this.preloadSliderImages = this.preloadSliderImages.bind(this);
  }

  componentDidMount() {
    this.preloadSliderImages();

    let slideImages = [...this.state.slideImages];
    let slideTexts = [...this.state.slideTexts];
    let slideImagesBegining = slideImages.slice(0, 2);
    let slideTextsBegining = slideTexts.slice(0, 2);
    let slideImagesEnd = slideImages.slice(
      slideImages.length - 2,
      slideImages.length
    );
    let slideTextsEnd = slideTexts.slice(
      slideTexts.length - 2,
      slideTexts.length
    );

    slideImages = slideImagesEnd.concat(slideImages);
    slideTexts = slideTextsEnd.concat(slideTexts);
    slideImages = slideImages.concat(slideImagesBegining);
    slideTexts = slideTexts.concat(slideTextsBegining);

    this.setState({ slideImages, slideTexts });

    this.setSliderPosition(this.state.activeSlideIndex);

    window.addEventListener("load", () => {
      this.setInitialSliderPosition();

      this.interval = setInterval(this.slide, 2000);
    });
  }

  componentWillUnmount() {
    window.removeEventListener("load", () => {
      this.setInitialSliderPosition();

      clearInterval(this.interval);
    });
  }

  preloadSliderImages() {
    const imagesMap = [
      ...this.state.slideImages.map((item) => item.backgroundImage),
      ...this.state.slideImages.map((item) => item.image),
    ];
    const mappedPromises = imagesMap.map((src) => preloadImage(src));

    Promise.all(mappedPromises).then(() => {
      this.setState({
        isImagesLoaded: true,
      });
    });
  }

  setInitialSliderPosition() {
    this.setState({ isTransitioned: false }, () =>
      this.setSliderPosition(this.state.activeSlideIndex)
    );
  }

  setSliderPosition(activeSlideIndex) {
    this.setState({ sliderPosition: activeSlideIndex * 100 });
  }

  slideBack() {
    if (!this.state.isSlid) {
      let { activeSlideIndex } = this.state;

      if (activeSlideIndex - 1 > 0) {
        activeSlideIndex = activeSlideIndex - 1;

        this.setState(
          { activeSlideIndex, isTransitioned: true, isSlid: true },
          () => this.setSliderPosition(activeSlideIndex)
        );

        setTimeout(() => this.setState({ isSlid: false }), 400);

        if (activeSlideIndex - 1 <= 0) {
          setTimeout(() => {
            activeSlideIndex = 5;

            this.setState({ activeSlideIndex, isTransitioned: false }, () =>
              this.setSliderPosition(activeSlideIndex)
            );
          }, 400);
        }
      }
    }
  }

  slide() {
    if (!this.state.isSlid) {
      let { activeSlideIndex } = this.state;

      if (activeSlideIndex + 1 < this.state.slideImages.length - 1) {
        activeSlideIndex = activeSlideIndex + 1;

        this.setState(
          { activeSlideIndex, isTransitioned: true, isSlid: true },
          () => this.setSliderPosition(activeSlideIndex)
        );

        setTimeout(() => this.setState({ isSlid: false }), 400);

        if (activeSlideIndex + 1 >= this.state.slideImages.length - 1) {
          setTimeout(() => {
            activeSlideIndex = 2;

            this.setState({ activeSlideIndex, isTransitioned: false }, () =>
              this.setSliderPosition(activeSlideIndex)
            );
          }, 400);
        }
      }
    }
  }

  render() {
    const {
      slideImages,
      slideTexts,
      activeSlideIndex,
      sliderPosition,
      isTransitioned,
      isSlid,
      isImagesLoaded,
    } = this.state;

    return (
      <div>
        <SliderView
          slideImages={slideImages}
          slideTexts={slideTexts}
          activeSlideIndex={activeSlideIndex}
          sliderPosition={sliderPosition}
          isTransitioned={isTransitioned}
          isSlid={isSlid}
          slide={this.slide}
          slideBack={this.slideBack}
          isImagesLoaded={isImagesLoaded}
        />
      </div>
    );
  }
}

export default Slider;
